import moment from 'moment';
import React from 'react';

/*
 * This file acts as placeholder for purpose built display overrides
 * - To add new translation simply guarantee that the keyed function exists here.
 * - And add this slug to the field config under "displayPrep" property
 *
 * */

export const translate = {
    RelativeTime: (v) => {
        if (v === undefined || v === null || v === '') {
            return 'Never';
        }
        return moment(v).fromDate();
    },
    FullDate: (v) => {
        if (v === undefined || v === null || v === '') {
            return 'Never';
        }
        return moment(v).format('YYYY-MM-DD hh:mm A');
    },
    ReadableDateTime: (v) => {
        if (v === undefined || v === null || v === '') {
            return 'Never';
        }
        return moment(v).format('MMMM Do YYYY, h:mm:ss a');
    },
    ReadableDateOnly: (v) => {
        if (v === undefined || v === null || v === '') {
            return 'Never';
        }
        return moment(v).format('MMMM/Do/YYYY');
    },
    ReadableDateTimeColumn: (v) => {
        if (v === undefined || v === null || v === '') {
            return 'Never';
        }
        return moment(v).format('MM/DD/YYYY hh:mm A');
    },
    ReadableDateColumn: (v) => {
        if (v === undefined || v === null || v === '') {
            return 'Never';
        }
        return moment(v).format('MM/DD/YYYY');
    }
};

export default (value, model) => {
    if (typeof value !== 'object' && typeof model === 'object') {
        if (typeof model.displayPrep === 'string' && typeof translate[model.displayPrep] === 'function') {
            return translate[model.displayPrep](value);
        } else if (typeof model.displayPrep === 'function') {
            return model.displayPrep(value);
        } else if (typeof model.enum === 'object' && typeof model.enum[value] === 'string') {
            return model.enum[value];
        }
    }
    return value;
};
